import { UserMapper } from "../user"
import { reserveAdjustmentReasons } from '../../../constants-v2'

/**
 * @typedef {import('../../js-doc').V2CreateReserveRequest} V2CreateReserveRequest
 * @typedef {import('../../js-doc').V2ReserveResponse} V2ReserveResponse
 * @typedef {import('../../js-doc').ReservePayload} ReservePayload
 * @typedef {import('../../js-doc').V2DefaultReserveMetadata} V2DefaultReserveMetadata
 * @typedef {import('../../js-doc').V2DirectPaymentByClientReserveMetadata} V2DirectPaymentByClientReserveMetadata
 * @typedef {import('../../js-doc').V2NonFactoredPaymentReserveMetadata} V2NonFactoredPaymentReserveMetadata
 * @typedef {import('../../js-doc').V2ReleaseOfFundsTo3rdPartyReserveMetadata} V2ReleaseOfFundsTo3rdPartyReserveMetadata
 * @typedef {import('../../js-doc').V2TransferFromReserveMetadata} V2TransferFromReserveMetadata
 * @typedef {import('../../js-doc').V2TransferToReserveMetadata} V2TransferToReserveMetadata
 * @typedef {import('../../js-doc').V1ReserveResponse} V1ReserveResponse
 */

/**
 * 
 * @param {V2ReserveResponse} v2Reserve - V2 reserve
 * @returns {V1ReserveResponse}
 */
export const mapV2Reserve = (v2Reserve) => {
  const v1Reserve = {
    amount: mapV2ResponseAmountToV1ResponseAmount(v2Reserve.amount),
    amount_paid: null,
    changelog_notes: null,
    client_id: v2Reserve.clientId,
    client_paymentid: v2Reserve?.clientPaymentId,
    created_at: v2Reserve.createdAt,
    created_by: v2Reserve.createdBy,
    debtor_payment_id: v2Reserve?.brokerPaymentId,
    deleted_at: v2Reserve?.updatedAt,
    deleted_by: v2Reserve?.updatedBy,
    firebase_key: null,
    id: v2Reserve.id,
    invoice_id: v2Reserve?.invoiceId,
    metadata: {
      check_number: v2Reserve.payload?.checkNumber,
      date_received: v2Reserve.payload?.batchDate || v2Reserve.payload?.receivedDate,
      debtor_id: v2Reserve.payload?.brokerId,
      debtor_name: v2Reserve.payload?.brokerName,
      load_number: v2Reserve.payload?.loadNumber,
      third_party: v2Reserve.payload?.thirdParty,
      transfer_type: v2Reserve.payload?.type,
    },
    nacha_sign: mapV2ReserveResponseAmountToV1NachaSign(v2Reserve.amount),
    notes: v2Reserve.note,
    quickbooks_journal_entry_id: null,
    reason: v2Reserve.reason,
    status_client_payment: null,
    total: Number(v2Reserve.total),
    transfer_clientid: v2Reserve.payload?.transferClientId,
    type: mapV2ReserveType(v2Reserve),
    updated_at: v2Reserve.updatedAt,
    updated_by: v2Reserve.updatedBy,
    updated_by_user: UserMapper.v2AuditResponseToV1(v2Reserve),
  }
  
  return v1Reserve
}

const mapV2ResponseAmountToV1ResponseAmount = (amount) => {
  return Number(Math.abs(amount))
}
  
const mapV2ReserveResponseAmountToV1NachaSign = (v2ResponseAmount) => {
  return Math.sign(v2ResponseAmount) >= 0
    ? '+'
    : '-'
}
  
/**
 * @param {V2ReserveResponse} v2Response - V2 reserve 
 * @returns {string}
 */
const mapV2ReserveType = (v2Response) => {
  if (v2Response.payload?.__payloadType === 'chargeback') {
    return 'approved invoice'
  }
  else if (v2Response.brokerPaymentId) {
    return 'debtor payment'
  }
  else if (reserveAdjustmentReasons.includes(v2Response.payload?.__payloadType)) {
    return 'client adjustments'
  }
  else if (v2Response.reason === 'reserve (entry)') {
    return 'reserve'
  }
  return ''
}
